import axios from 'axios';
import type { GeoLocation } from './types/geo-location';

export default class LocationService {
  static async getGeoLocation(): Promise<GeoLocation> {
    const { data } = await axios.get('/get/login/geoip');

    return data;
  }
}
